import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
interface FooterProps {
  language: 'en' | 'es';
}
export function Footer({
  language
}: FooterProps) {
  const t = {
    en: {
      description: 'Reliable portable restroom and trailer rentals across West Texas.',
      callOrText: 'Call or Text Us',
      quickLinks: 'Quick Links',
      home: 'Home',
      services: 'Services',
      serviceAreas: 'Service Areas',
      faq: 'FAQ',
      contact: 'Contact',
      needQuote: 'Need a Quote?',
      quoteDesc: 'Get clean units, fast delivery, and dependable local service.',
      quoteBtn: 'REQUEST A FREE QUOTE →',
      rights: '© 2026 Blackstone Rentals LLC. All Rights Reserved.',
      tagline: 'Designed for West Texas. Built with Pride.',
      privacy: 'Privacy Policy',
      terms: 'Terms & Conditions',
      cookies: 'Cookie Policy',
      ada: 'ADA Compliance',
      privacyShort: 'Privacy Policy',
      termsShort: 'Terms'
    },
    es: {
      description: 'Renta confiable de baños portátiles y remolques en todo West Texas.',
      callOrText: 'Llámanos o Escríbenos',
      quickLinks: 'Enlaces Rápidos',
      home: 'Inicio',
      services: 'Servicios',
      serviceAreas: 'Áreas de Servicio',
      faq: 'Preguntas Frecuentes',
      contact: 'Contacto',
      needQuote: '¿Necesitas Cotización?',
      quoteDesc: 'Unidades limpias, entrega rápida y servicio local confiable.',
      quoteBtn: 'SOLICITA COTIZACIÓN GRATIS →',
      rights: '© 2026 Blackstone Rentals LLC. Todos los Derechos Reservados.',
      tagline: 'Diseñado para West Texas. Hecho con Orgullo.',
      privacy: 'Política de Privacidad',
      terms: 'Términos y Condiciones',
      cookies: 'Política de Cookies',
      ada: 'Cumplimiento ADA',
      privacyShort: 'Política de Privacidad',
      termsShort: 'Términos'
    }
  };
  const text = t[language];
  return <footer className="bg-footerBg pt-10 md:pt-16 pb-8 border-t border-steel w-full overflow-hidden" data-id="element-79">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-80">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-8 md:mb-12" data-id="element-81">
          <div className="text-center md:text-left" data-id="element-82">
            <a href="#home" className="inline-block mb-5" data-id="element-83">
              <img src="https://cdn.magicpatterns.com/uploads/6XMJLNcqaWm4GULsPBmP2x/logo_1.png" alt="Blackstone Rentals LLC" className="h-14 w-auto mx-auto md:mx-0" data-id="element-84" />
            </a>
            <p className="font-inter text-gray-400 text-sm leading-relaxed mb-6 max-w-[280px] mx-auto md:mx-0" data-id="element-85">
              {text.description}
            </p>
            <div className="flex flex-col gap-3 font-inter text-gray-300 text-sm" data-id="element-86">
              <span className="flex items-center justify-center md:justify-start gap-2.5" data-id="element-87">
                <MapPin size={16} color="#C9952A" className="flex-shrink-0" data-id="element-88" />
                Odessa, TX
              </span>
              <span className="font-montserrat text-gold text-xs font-bold tracking-widest uppercase mt-1" data-id="element-89">
                {text.callOrText}
              </span>
              <div className="flex items-center justify-center md:justify-start gap-3" data-id="element-90">
                <Phone size={16} color="#C9952A" className="flex-shrink-0" data-id="element-91" />
                <a href="tel:+14325287892" className="hover:text-gold transition-colors" data-id="element-92">
                  432-528-7892
                </a>
                <a href="sms:+14325287892" className="text-gold hover:text-yellow-500 transition-colors text-xs font-semibold" data-id="element-93">
                  [text]
                </a>
              </div>
              <div className="flex items-center justify-center md:justify-start gap-3" data-id="element-94">
                <Phone size={16} color="#C9952A" className="flex-shrink-0" data-id="element-95" />
                <a href="tel:+14328034737" className="hover:text-gold transition-colors" data-id="element-96">
                  432-803-4737
                </a>
                <a href="sms:+14328034737" className="text-gold hover:text-yellow-500 transition-colors text-xs font-semibold" data-id="element-97">
                  [text]
                </a>
              </div>
              <a href="mailto:blackstonerentals.99@gmail.com" className="flex items-center justify-center md:justify-start gap-2.5 hover:text-gold transition-colors" data-id="element-98">
                <Mail size={16} color="#C9952A" className="flex-shrink-0" data-id="element-99" />
                blackstonerentals.99@gmail.com
              </a>
              <span className="flex items-center justify-center md:justify-start gap-2.5 text-gold" data-id="element-100">
                <Clock size={16} color="#C9952A" className="flex-shrink-0" data-id="element-101" />
                Available 24/7
              </span>
            </div>
          </div>
          <div className="text-center md:text-left" data-id="element-102">
            <h4 className="font-montserrat text-warmWhite font-bold text-sm tracking-widest uppercase mb-6" data-id="element-103">
              {text.quickLinks}
            </h4>
            <ul className="space-y-3 font-inter text-gray-400 text-sm" data-id="element-104">
              <li data-id="element-105">
                <a href="#home" className="hover:text-gold transition-colors" data-id="element-106">
                  {text.home}
                </a>
              </li>
              <li data-id="element-107">
                <a href="#services" className="hover:text-gold transition-colors" data-id="element-108">
                  {text.services}
                </a>
              </li>
              <li data-id="element-109">
                <a href="#service-areas" className="hover:text-gold transition-colors" data-id="element-110">
                  {text.serviceAreas}
                </a>
              </li>
              <li data-id="element-111">
                <a href="#faq" className="hover:text-gold transition-colors" data-id="element-112">
                  {text.faq}
                </a>
              </li>
              <li data-id="element-113">
                <a href="#contact" className="hover:text-gold transition-colors" data-id="element-114">
                  {text.contact}
                </a>
              </li>
            </ul>
            <div className="border-t border-gold/20 mt-3 pt-3" data-id="element-115">
              <ul className="space-y-3 font-inter text-gray-400 text-sm" data-id="element-116">
                <li data-id="element-117">
                  <Link to="/privacy" className="hover:text-gold transition-colors" data-id="element-118">
                    {text.privacyShort}
                  </Link>
                </li>
                <li data-id="element-119">
                  <Link to="/terms" className="hover:text-gold transition-colors" data-id="element-120">
                    {text.termsShort}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="text-center md:text-left" data-id="element-121">
            <h4 className="font-montserrat text-warmWhite font-bold text-sm tracking-widest uppercase mb-6" data-id="element-122">
              {text.needQuote}
            </h4>
            <p className="font-inter text-gray-400 text-sm leading-relaxed mb-6 max-w-[280px] mx-auto md:mx-0" data-id="element-123">
              {text.quoteDesc}
            </p>
            <a href="#quote" className="inline-block bg-gold text-obsidian px-8 py-3.5 rounded font-montserrat font-bold text-sm tracking-wide hover:bg-yellow-500 hover:scale-105 transition-all duration-300" data-id="element-124">
              {text.quoteBtn}
            </a>
          </div>
        </div>
        <div className="pt-6 border-t border-steel text-center font-inter text-xs text-gray-500" data-id="element-125">
          <p data-id="element-126">{text.tagline}</p>
        </div>
      </div>

      {/* Legal Bar */}
      <div className="border-t border-gold/20 mt-6" data-id="element-127">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col md:flex-row justify-between items-center gap-3 md:gap-4" data-id="element-128">
          <p className="font-inter text-xs text-warmWhite/50 text-center md:text-left" data-id="element-129">
            {text.rights}
          </p>
          <div className="flex flex-wrap justify-center md:justify-end gap-x-2 gap-y-1 font-inter text-xs text-warmWhite/40" data-id="element-130">
            <Link to="/privacy" className="hover:text-gold hover:underline transition-colors" data-id="element-131">
              {text.privacy}
            </Link>
            <span className="text-warmWhite/20" data-id="element-132">|</span>
            <Link to="/terms" className="hover:text-gold hover:underline transition-colors" data-id="element-133">
              {text.terms}
            </Link>
            <span className="text-warmWhite/20" data-id="element-134">|</span>
            <Link to="/cookies" className="hover:text-gold hover:underline transition-colors" data-id="element-135">
              {text.cookies}
            </Link>
            <span className="text-warmWhite/20" data-id="element-136">|</span>
            <Link to="/ada" className="hover:text-gold hover:underline transition-colors" data-id="element-137">
              {text.ada}
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}